import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const Padlock24 = (props: SvgIconProps): JSX.Element => React.createElement(
    SvgIcon,
    props,
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <path d='M12 14C11.4477 14 11 14.4477 11 15V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V15C13 14.4477 12.5523 14 12 14Z' fill='currentColor' />
        <path fillRule='evenodd' clipRule='evenodd' d='M6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V9.53513L17.8829 9.46999C19.1428 10.1434 20 11.4716 20 13V19C20 21.2091 18.2091 23 16 23H8C5.79086 23 4 21.2091 4 19V13C4 11.4716 4.85722 10.1434 6.1171 9.46999L6 9.53513V7ZM16 7V9H8V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM8 11C6.89543 11 6 11.8954 6 13V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V13C18 11.8954 17.1046 11 16 11H8Z' fill='currentColor' />
        <path d='M11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15Z' fill='currentColor' />
    </svg>,
);
